// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c92982d","455":"831342ec","488":"b68e00fc","977":"6c4f6cf1"}[chunkId] + ".chunk.js";
};